export const ANNOUNCEMENT_DISMISS_KEY = 'reconAnnouncementDismissed';

/**
 * The one live announcement. Set to null when the notice should come down.
 * A new id shows again in browsers that dismissed the previous one.
 */
export const currentAnnouncement = {
	id: 'nav-moved-2026',
	text: 'We\u2019ve added notifications so you never miss an action item. Look for the new bell icon in the updated header. If you have any questions, our support team is happy to help',
};

export function dismissedAnnouncementId() {
	try {
		return localStorage.getItem(ANNOUNCEMENT_DISMISS_KEY);
	} catch {
		return null;
	}
}

export function dismissAnnouncement(id) {
	try {
		localStorage.setItem(ANNOUNCEMENT_DISMISS_KEY, id);
	} catch {
		// The in-memory hide still closes it for this visit.
	}
}

export function isAnnouncementDismissed(id) {
	if (!id) return false;
	return dismissedAnnouncementId() === id;
}
